import React from 'react';
import _ from 'underscore';
import {
  Alert,
  FormGroup,
  FormControl,
  ControlLabel,
  ButtonToolbar,
  DropdownButton,
  MenuItem,
  Modal,
  Col,
  Button,
  Row,
} from 'react-bootstrap';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import SelectReasonCodes from 'components/modules/marketplace-config/SelectReasonCodes';
import { withTranslation } from 'react-i18next';

class Attempt extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      meta: {
        reason: '',
        type: '',
        message: '',
      },
      reason: null,
      comment: '',
      commentRequired: false,
    };
  }

  // Props for stop comes in late to the modal
  UNSAFE_componentWillReceiveProps(nextProps) {
    const type =
      nextProps.stop && nextProps.stop.action === 'pickup'
        ? 'Attempted Pickup'
        : 'Attempted Delivery';
    const { meta } = this.state;
    meta.type = type;
    this.setState({ meta });
  }

  getTitle() {
    const { t } = this.props;
    let title = t('ATTEMPT_DETAILS_DATA', {
      data: this.props.shipment.shipment_id,
    });

    if (this.props.stop && this.props.sequence) {
      title += t('STOP_ADDON_DATA', { data: this.props.stop.sequence });
    }
    return title;
  }

  renderStopSelection() {
    return this.props.shipment.stops.map((stop) => (
      <MenuItem key={stop._id} eventKey={stop._id}>
        {stop.location[0].address}
      </MenuItem>
    ));
  }

  isValid() {
    return !this.state.error && this.state.meta.reason && this.state.meta.type;
  }

  handleTypeSelect(type) {
    const meta = this.state.meta;
    meta.type = type;
    this.setState({ type });
  }

  handleReasonSelect = (item) => {
    const { meta } = this.state;
    meta.reason = item;
    this.setState({ meta });
  };

  handleCommentInput = (comment) => {
    if (comment.length) {
      this.setState((currentState) => {
        const { meta } = this.state;
        meta.message = comment;
        return { meta, comment, commentRequired: false, error: null };
      });
    } else {
      this.setState({ comment });
    }
  };

  handleCommentRequired = (value) => {
    const { t } = this.props;
    if (value) {
      this.setState({
        error: t('CUSTOM_REASON_CODE_REQUIRE_COMMENT'),
        commentRequired: value,
      });
    } else {
      this.setState({ commentRequired: value });
    }
  };

  handleStopSelection(stopId) {
    this.setState((prevState) => {
      const meta = prevState.meta;
      meta.returnStopId = stopId;
      return {
        meta,
        error: null,
      };
    });
  }

  onHideModal() {
    this.setState({ meta: { reason: '', type: '', message: '' } }, () => {
      this.props.onHideModal();
    });
  }

  handleCloseShipment() {
    const data = this.state.meta;
    this.props.onClose(this.props.shipment, this.props.stop, 'attempt', data);
    this.onHideModal();
  }

  render() {
    const { t } = this.props;
    return (
      <Modal show={this.props.show} onHide={() => this.onHideModal} enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>{this.getTitle()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={12}>
              <p>{t('ATTEMPT_STOP_MESSAGE')}</p>
            </Col>
          </Row>
          <Row>
            <Col xs={5}>
              <p>{t('SELECT_TYPE_OF_COMMENT')}</p>
            </Col>
            <Col xs={7}>
              <DropdownButton
                bsStyle={this.state.meta.type ? 'success' : 'default'}
                id="attempt-types"
                title={this.state.meta.type || t('SELECT_TYPE')}
                onSelect={(key) => this.handleTypeSelect(key)}
              >
                <MenuItem eventKey="Attempted Pickup">
                  {t('ATTEMPTED_PICKUP')}
                </MenuItem>
                <MenuItem eventKey="Attempted Delivery">
                  {t('ATTEMPTED_DELIVERY')}
                </MenuItem>
              </DropdownButton>
            </Col>
          </Row>
          <Row style={{ marginTop: 30 }}>
            <Col xs={12}>
              <SelectReasonCodes
                shipment={this.props.shipment}
                category="stop_complete"
                updateComment={this.handleCommentInput}
                selectReasonCode={this.handleReasonSelect}
                updateCommentRequired={this.handleCommentRequired}
              />
            </Col>
          </Row>
          {1 === 2 && (
            <Row>
              <Col xs={5}>{t('FRIEGHT_RETURNED_QUES')}</Col>
              <Col xs={7}>
                <DropdownButton
                  id="stop-selection"
                  title={t('SELECT_RETURN_ADDRESS')}
                  onSelect={(key) => this.handleStopSelection(key)}
                >
                  {this.renderStopSelection()}
                </DropdownButton>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={12}>
              <p className="text-muted" style={{ float: 'right' }}>
                {this.state.meta.type && this.state.meta.reason
                  ? t('CLOSING_SHIPMENT_TYPE_WITH_REASON', {
                      shipmentId: this.props.shipment.shipment_id,
                      shipmentType: this.state.meta.type,
                      description: this.state.meta.reason.description,
                    })
                  : null}
              </p>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <ButtonToolbar style={{ float: 'right' }}>
                <Button onClick={() => this.onHideModal()}>Cancel</Button>
                <Button
                  disabled={!this.isValid()}
                  onClick={() => this.handleCloseShipment()}
                  bsStyle="danger"
                >
                  {t('ATTEMPT')}
                </Button>
              </ButtonToolbar>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default withTranslation()(Attempt);
